const EDITABLE_TAG_NAMES = ['INPUT', 'TEXTAREA', 'SELECT'];

const ARROW_CONSUMING_SELECTOR = [
  'video',
  'audio',
  'canvas',
  '[contenteditable="true"]',
  '[role="slider"]',
  '[role="listbox"]',
  '[role="menu"]',
].join(',');

const isEditableTarget = (element: HTMLElement): boolean => (
  element.isContentEditable || EDITABLE_TAG_NAMES.includes(element.tagName)
);

const hasLayoutSize = (element: HTMLElement): boolean => (
  element.offsetWidth > 0 && element.offsetHeight > 0
);

export const isOverlayOpen = (): boolean => (
  document.body.style.overflow === 'hidden'
  || !!document.querySelector('[aria-modal="true"]')
);

export const shouldIgnoreArrowNavigation = (event: KeyboardEvent): boolean => {
  if (event.defaultPrevented) return true;
  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return true;
  if (isOverlayOpen()) return true;

  const target = event.target as HTMLElement | null;
  if (!target || typeof target.closest !== 'function') return false;

  return (isEditableTarget(target) && hasLayoutSize(target))
    || !!target.closest(ARROW_CONSUMING_SELECTOR);
};
